import { useState } from "react";
import { POSICAO_MODULO } from "src/components/projetos/constants";
import { SelectWithImageInOption } from "src/components/projetos/dimensionados/containers/Modulos/containers/SelectWithImageInOption";
import { OptionWithImage, PosicaoModulo } from "src/components/projetos/types";
import { useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store";
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types";

interface PosicaoModuloInputProps {
  errorState: string[];
  formState: FormProjetoHibridoType;
  onChangeValue: (formState: Partial<FormProjetoHibridoType>) => void;
}

export const PosicaoModuloInput = ({ errorState, formState, onChangeValue }: PosicaoModuloInputProps) => {
  const projetoHibridoStoreActions = useProjetosHibridoStore(store => store.actions)
  const projetoHibridoStoreState = useProjetosHibridoStore(store => store.state)
  
  const selectedOption = projetoHibridoStoreState.data.fileiras?.[0]?.posicao_modulo || null

  return (
    <SelectWithImageInOption
        id="custom-select-posicao-modulo"
        label="* Posição do módulo"
        onChange={(d) => {
          const dLocal = d as OptionWithImage<PosicaoModulo>
          projetoHibridoStoreActions.atualizaOrCriaFileira({ posicao_modulo: dLocal || null }, 0);
          projetoHibridoStoreActions.checkEstruturaSelecionada({ triggerValidation: false });
        }}
        disabled={!formState.modulo_selecionado}
        value={selectedOption}
        options={POSICAO_MODULO}
      />

  )
}